import { WMRateScheduleHeaderLookupLayout, WMItemDpLookupLayout, WMCodesLookupLayout, } from '../../../../common/lookups/Layouts/WMLayouts';
import { IDCustomerWithQuickAddLookupLayout,IDCustomerLookupLayout, IDBuyerLookupLayout, IDConsigneeLookupLayout, IDManufacturerLookupLayout } from '../../../../common/lookups/Layouts/IdLayouts';
import { EDLookupLayout, EDHazardousLayout } from '../../../../common/lookups/Layouts/EDLayouts';
import { ABPopupMessageLayout } from '../../../../common/lookups/Layouts/ABLayouts';
import { CAJobLayout } from '../../../../common/lookups/Layouts/CALayouts';
import { ACDepartmentLayout } from '../../../../common/lookups/Layouts/ACLayouts';
import { FAFundLayout } from '../../../../common/lookups/Layouts/FALayouts';
import { IDWarehouseLookupLayout } from '../../../../common/lookups/Layouts/IdLayouts';
import Form from "../../../components/quickadd/customer/Form";
import MainTab from '../../../../id/codes/customerDataEntry/MainTab';

const customerLayout = IDCustomerWithQuickAddLookupLayout({
    onCustomItemCreatingComponent: MainTab,
    IdType:"01",
    onCustomItemCreatingQuickComponent: Form, 
  });
const classCodes = WMCodesLookupLayout({codeType: '28' });
const subClassCodes = WMCodesLookupLayout({ codeType: '29' });
const physicalCountCodes = WMCodesLookupLayout({ codeType: '32' });
const receiptCodes = WMCodesLookupLayout({codeType: '30' });
const shipmentCodes = WMCodesLookupLayout({ codeType: '31' });
const edHazardousLayout = EDHazardousLayout();
const eDLookupLayout = EDLookupLayout({ Dataelementnum: '355' ,Versionid: '4010'});
const freightClassCodes = WMCodesLookupLayout({ codeType: '33' });
const holdReasonCodes = WMCodesLookupLayout({ codeType: '02' });
const popupMessageLayout = ABPopupMessageLayout({ tableName: 'IMITEM' });
const runtimeParameter = JSON.stringify([
    { RATESELECTION: 'RATESELECTION' },
    { R_IDENTITY: 'R_IDENTITY' },
    {CLASSCODE:'CLASSCODE'},
    {SUBCLASSCODE:'SUBCLASSCODE'},
    {R_PROFILE:'R_PROFILE'},
  ]);
const ratescheduleCodes = WMRateScheduleHeaderLookupLayout({
    status: 'A', type: "I",
    runtimeParameter
});

const SearchLayout = [
    {
        "groupId": 1,
        "fields": [
            {
                "name": "RECORD",
                "tableName": "IMITEM",
                "localizedField": "Keysequence",
                "label": "Record #",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "STATUS",
                "tableName": "IMITEM",
                "label": "Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 2,
        "fields": [
            {
                "name": "WHID",
                "tableName": "IMITEM",
                "label": "Warehouse",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RCustomer",
                "tableName": "IMITEM",
                "label": "Customer",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "fields": [
            {
                "name": "ITEMCODE",
                "tableName": "IMITEM",
                "label": "Item",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PROFILECODE",
                "tableName": "IMITEMDP",
                "label": "Profile",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }


        ]
    },
    {
        "groupId": 4,
        "fields": [
            {
                "name": "CLASSCODE",
                "tableName": "IMITEM",
                "label": "Class",
                "type": "lookup",
                "layout": classCodes,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "SUBCLASSCODE",
                "tableName": "IMITEM",
                "label": "Sub Class",
                "type": "lookup",
                "layout": subClassCodes,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
];

const PrimaryLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "RECORD",
                "localizedField": "KEYSEQUENCE",
                "tableName": "IMITEM",
                "label": "Record #",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "R_PROFILE",
                "tableName": "IMITEM",
                "label": "Profile",
                "type": "lookup",
                "lookupDisplayMode": "grid",
                "layout": WMItemDpLookupLayout,
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_IDENTITY",
                "tableName": "IMITEM",
                "label": "Customer",
                "type": "lookup",
                "layout": customerLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ITEMCODE",
                "tableName": "IMITEM",
                "label": "Item",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "DESCRIPTION_1",
                "tableName": "IMITEM",
                "label": "Description - 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "DESCRIPTION_2",
                "tableName": "IMITEM",
                "label": "Description - 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "ITEMTYPE",
                "tableName": "IMITEM",
                "label": "Item Type",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            }
        ]
    },
    {
        "groupId": 2,
        "fields": [
            {
                "name": "CLASSCODE",
                "tableName": "IMITEM",
                "label": "Class",
                "type": "lookup",
                "layout": classCodes,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "STATUS",
                "tableName": "IMITEM",
                "label": "Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "SUBCLASSCODE",
                "tableName": "IMITEM",
                "label": "Sub Class",
                "type": "lookup",
                "layout": subClassCodes,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DATEINTRODUCED",
                "tableName": "IMITEM",
                "label": "Introduced Dt",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DATEAVAILABLE",
                "tableName": "IMITEM",
                "label": "Available Dt",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DATEEXPIRATION",
                "tableName": "IMITEM",
                "label": "Expiration Dt",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PHYSICALCOUNTCODE",
                "tableName": "IMITEM",
                "label": "Count Cycle",
                "type": "lookup",
                "layout": physicalCountCodes,
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }

        ]
    }
]


const AdditionalLayout = [
    {
        "groupId": 1,
        "label": "Rate Schedule",
        "fields": [
            {
                "name": "RATESOURCE",
                "tableName": "IMITEM",
                "label": "Rate Source",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RATESELECTION",
                "tableName": "IMITEM",
                "label": "Rate Selection",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_RATESCHEDULE",
                "tableName": "IMITEM",
                "label": "Rate Schedule",
                "type": "lookup",
                "layout": ratescheduleCodes,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "Stoarge Billing",
        "fields": [
            {
                "name": "STORAGEBILLINGSTARTDATE",
                "tableName": "IMITEM",
                "label": "Start",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "STORAGEBILLINGENDDATE",
                "tableName": "IMITEM",
                "label": "End",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "STORAGEBILLEDDATE_LAST",
                "tableName": "IMITEM",
                "label": "Last",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PREVSTORAGEBILLEDDATE_LAST",
                "tableName": "IMITEM",
                "label": "Previous Last",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "STORAGEBILLEDDATE_NEXT",
                "tableName": "IMITEM",
                "label": "Next",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PREVSTORAGEBILLEDDATE_NEXT",
                "tableName": "IMITEM",
                "label": "Previous Next",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RECURRINGSTORAGE",
                "tableName": "IMITEM",
                "label": "Recurring Flag",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "Accounting",
        "fields": [
            {
                "name": "MANAGEMENTSOURCE",
                "tableName": "IMITEM",
                "label": "Mgmt Source",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_GLDEPARTMENT",
                "tableName": "IMITEM",
                "label": "Department",
                "type": "lookup",
                "layout": ACDepartmentLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_GLFUND",
                "tableName": "IMITEM",
                "label": "GL Fund",
                "type": "lookup",
                "layout": FAFundLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_CAJOBCODE",
                "tableName": "IMITEM",
                "label": "CA Job",
                "type": "lookup",
                "layout": CAJobLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 4,
        "label": "Miscellaneous Information",
        "fields": [
            {
                "name": "OEMMANUFACTURERCODE",
                "tableName": "IMITEM",
                "label": "OEM Code",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_OEMMANUFACTUREID",
                "tableName": "IMITEM",
                "label": "Manuf ID",
                "type": "lookup",
                "layout": IDManufacturerLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_DESTINATIONID",
                "tableName": "IMITEM",
                "label": "Destination ID",
                "type": "lookup",
                "layout": IDConsigneeLookupLayout({valueExpr:'id',displayExpr:'identityid'}),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_BUYER",
                "tableName": "IMITEM",
                "label": "Buyer",
                "type": "lookup",
                "layout": IDBuyerLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "FREIGHTCLASSCODE",
                "tableName": "IMITEM",
                "label": "Freight Class",
                "type": "lookup",
                "layout": freightClassCodes,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ITEMSUPCCODE",
                "tableName": "IMITEM",
                "label": "Alternate SKU",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 5,
        "label": "Receipt Hold/Off Hold",
        "fields": [
            {
                "name": "RECEIPTPUTONHOLD",
                "tableName": "IMITEM",
                "label": "Rec on Hold",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "HOLDREASONCODE",
                "tableName": "IMITEM",
                "label": "Reason Code",
                "type": "lookup",
                "layout": holdReasonCodes,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "HOLDDAYSCOUNT",
                "tableName": "IMITEM",
                "label": "Hold Days",
                "type": "number", 
                "format": "#,###",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 6,
        "label": "Popup Message",
        "fields": [
            {
                "name": "POPUPMESSAGE",
                "tableName": "IMITEM",
                "label": "Popup Msg",
                "type": "lookup",
                "layout": popupMessageLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 7,
        "label": "Location Default",
        "fields": [
            {
                "name": "LOCATIONAVAILABLEDEFAULT",
                "tableName": "IMITEM",
                "label": "Available",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "LOCATIONREASONCODEDEFAULT",
                "tableName": "IMITEM",
                "label": "Available",
                "type": "lookup",
                "layout": holdReasonCodes,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 8,
        "label": "",
        "fields": [
            {
                "name": "COMMENT",
                "tableName": "IMITEM",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    }
]

const UOMLayout = [
     {
        "groupId": 1,
        "label": "Inventory Quantity Factors",
        "fields": [
            {
                "name": "INVENTORYUNITNOTUSED",
                "tableName": "IMITEM",
                "label": "Inventory Unit",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true,
            },
            {
                "name": "PIECESPERUNITQUANTITY",
                "tableName": "IMITEM",
                "label": "Pieces/Unit",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "UNITSPERPACKAGEQUANTITY",
                "tableName": "IMITEM",
                "label": "Units/Pkg",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "PACKAGESPERSHIPPINGUNITQTY",
                "tableName": "IMITEM",
                "label": "Pkg/Ship",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "UOM",
        "fields": [
            {
                "name": "INVENTORYUNITUOM",
                "tableName": "IMITEM",
                "label": "Inventory Unit",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PIECESPERUNITUOM",
                "tableName": "IMITEM",
                "label": "Pieces/Unit",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "UNITSPERPACKAGEUOM",
                "tableName": "IMITEM",
                "label": "Units/Pkg",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "PACKAGESPERSHIPPINGUNITUOM",
                "tableName": "IMITEM",
                "label": "Pkg/Ship",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "Source",
        "fields": [
            {
                "name": "INVENTORYQUANTITYSOURCE",
                "tableName": "IMITEM",
                "label": "Inventory Unit",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    },
    {
        "groupId": 4,
        "label": "Sizes",
        "fields": [
            {
                "name": "SIZE_1",
                "tableName": "IMITEM",
                "label": "Size - 1",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

            {
                "name": "SIZE_2",
                "tableName": "IMITEM",
                "label": "Size - 2",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

        ]
    },
     {
        "groupId": 5,
        "label": "Quantity Per Inventory Unit",
        "fields": [
            {
                "name": "UNITVOLUMEQUANTITY",
                "tableName": "IMITEM",
                "label": "Unit Volume",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UNITAREAQUANTITY",
                "tableName": "IMITEM",
                "label": "Unit Area",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "UNITVALUEQUANTITY",
                "tableName": "IMITEM",
                "label": "Unit Value",
                "type": "number",
                "format": "$ #,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "NETWEIGHTQUANTITY",
                "tableName": "IMITEM",
                "label": "Unit Net Wt",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "GROSSMINUSNET",
                "tableName": "IMITEM",
                "label": "Unit Tare Wt",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "GROSSWEIGHTQUANTITY",
                "tableName": "IMITEM",
                "label": "Unit Gross Wt",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 6,
        "label": "UOM",
        "fields": [
            {
                "name": "UNITVOLUMEUOM",
                "tableName": "IMITEM",
                "label": "Unit Volume",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UNITAREAUOM",
                "tableName": "IMITEM",
                "label": "Unit Area",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "UNITVALUEUOM",
                "tableName": "IMITEM",
                "label": "Unit Value",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "NETWEIGHTUOM",
                "tableName": "IMITEM",
                "label": "Unit Net Wt",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "NETWEIGHTUOM",
                "tableName": "IMITEM",
                "label": "Unit Tare Wt",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true,
            }
            ,
            {
                "name": "GROSSWEIGHTUOM",
                "tableName": "IMITEM",
                "label": "Unit Gross Wt",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 7,
        "label": "Source",
        "fields": [
           {
                "name": "WEIGHTBASISFLAG",
                "tableName": "IMITEM",
                "label": "Unit Volume",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 8,
        "label": "EDI/RF Validation of Serial #s",
        "fields": [
            {
                "name": "RFRECEIPTVALIDATION",
                "tableName": "IMITEM",
                "label": "Receipt",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

            {
                "name": "RFSHIPMENTVALIDATION",
                "tableName": "IMITEM",
                "label": "Shipment",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

        ]
    }
    ,
    {
        "groupId": 9,
        "label": "Transaction Defaults",
        "fields": [
            {
                "name": "RECEIPTUOMDEFAULT",
                "tableName": "IMITEM",
                "label": "Receipt",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

            {
                "name": "SHIPMENTUOMDEFAULT",
                "tableName": "IMITEM",
                "label": "Shipment",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

        ]
    }
        ,
    {
        "groupId": 10,
        "label": "Pack & Size",
        "fields": [
            {
                "name": "RECEIPTPACKSIZE",
                "tableName": "IMITEM",
                "label": "Receipt",
                "type": "lookup",
                "layout": receiptCodes,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

            {
                "name": "SHIPMENTPACKSIZE",
                "tableName": "IMITEM",
                "label": "Shipment",
                "type": "lookup",
                "layout": shipmentCodes,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

        ]
    }
]

const StatusLayout = [
    {
        "groupId": 1,
        "label": "Quantity Status",
        "fields": [
            {
                "name": "BeginPeriod",
                "tableName": "IMITEM",
                "label": "Begin Period",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },{
                "name": "ON_HAND",
                "tableName": "IMITEM",
                "label": "On Hand",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },{
                "name": "IN_RECEIVING",
                "tableName": "IMITEM",
                "label": "In Receiving",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },{
                "name": "OUT_SHIPPED",
                "tableName": "IMITEM",
                "label": "In Shipping",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },{
                "name": "OUT_UNAVAILABLE",
                "tableName": "IMITEM",
                "label": "Unavailable",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },{
                "name": "AVAILABLE",
                "tableName": "IMITEM",
                "label": "Available",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },{
                "name": "IN_ORDERED",
                "tableName": "IMITEM",
                "label": "Pending Rec",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },{
                "name": "OUT_ORDERED",
                "tableName": "IMITEM",
                "label": "Pending Ship",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },{
                "name": "NETAVAILABLE",
                "tableName": "IMITEM",
                "label": "Net Available",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },{
                "name": "IN_FUTURE",
                "tableName": "IMITEM",
                "label": "Future Rec",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },{
                "name": "OUT_FUTURE",
                "tableName": "IMITEM",
                "label": "Future Ship",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "Reorder Information",
        "fields": [
            {
                "name": "REORDERMETHODFLAG",
                "tableName": "IMITEM",
                "label": "Method",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            } ,
            {
                "name": "REORDERINVENTORYMINIMUMQTY",
                "tableName": "IMITEM",
                "label": "Minimum Quantity",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "REORDERINVENTORYMAXIMUMQTY",
                "tableName": "IMITEM",
                "label": "Maximum Quantity",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "REORDERMINIMUMDAYSONHAND",
                "tableName": "IMITEM",
                "label": "Minimum Days",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "REORDERMAXIMUMDAYSONHAND",
                "tableName": "IMITEM",
                "label": "Maximum Days",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "REORDERQUANTITYENTERED",
                "tableName": "IMITEM",
                "label": "Entered Qty",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "REORDERQUANTITYEOQCALCULATED",
                "tableName": "IMITEM",
                "label": "Calculated Qty",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "REORDERQUANTITYORDERMULTIPLE",
                "tableName": "IMITEM",
                "label": "Order Multiple",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "REORDERSAFETYQUANTITY",
                "tableName": "IMITEM",
                "label": "Safety Qty",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "REORDERLEADTIME",
                "tableName": "IMITEM",
                "label": "Lead Days",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    } ,
    {
        "groupId": 3,
        "label": "Expiration Days on Receipt",
        "fields": [
            {
                "name": "WARRANTYFLAG",
                "tableName": "IMITEM",
                "label": "Source",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            } ,{
                "name": "CHECKRECEIPTDAYS",
                "tableName": "IMITEM",
                "label": "Chk Rec Days",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            } ,
            {
                "name": "WARRANTYMONTHS",
                "tableName": "IMITEM",
                "label": "Receipt Days",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },{
                "name": "CHECKMAXDAYS",
                "tableName": "IMITEM",
                "label": "Chk Max Days",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }  ,
            {
                "name": "MAXDAYS",
                "tableName": "IMITEM",
                "label": "Max Days",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },{
                "name": "CHECKLOTEXPIRATION",
                "tableName": "IMITEM",
                "label": "Check Lot Exp",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    } ,
    {
        "groupId": 4,
        "label": "Expiration Days on Shipments",
        "fields": [
            {
                "name": "WARRANTYFLAG_SHIPMENT",
                "tableName": "IMITEM",
                "label": "Source",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }  ,
            {
                "name": "CHECKSHIPMENTDAYS",
                "tableName": "IMITEM",
                "label": "Chk Ship Days",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            } ,
            {
                "name": "WARRANTYMONTHS_SHIPMENT",
                "tableName": "IMITEM",
                "label": "Ship Days",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "WMCONSIGNEEEXPDAYS",
                "tableName": "IMITEM",
                "label": "Consignee Adj Days",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            } 
        ]
    } ,
    {
        "groupId": 5,
        "label": "Lot expiration date generation",
        "fields": [
            {
                "name": "EXPDATEBASEDON",
                "tableName": "IMITEM",
                "label": "Based on",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }  ,
            {
                "name": "ADDTOEXPDATE",
                "tableName": "IMITEM",
                "label": "Add Days",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 6,
        "label": "Historical Information",
        "fields": [
            {
                "name": "INTRANSACTIONNUMBER",
                "tableName": "IMITEM",
                "label": "First Receipt",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,

            }  
        ]
    } 
]

const CodesLayout = [

    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDCODE_1",
                "localizedField": "USERDEFINEDCODE_1",
                "tableName": "IMITEM",
                "label": "CODE 2",
                "type": "lookup",
                "layout": WMCodesLookupLayout({codeType: '18' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_2",
                "localizedField": "USERDEFINEDCODE_2",
                "tableName": "IMITEM",
                "label": "CODE 2",
                "type": "lookup",
                "layout": WMCodesLookupLayout({codeType: '19' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_3",
                "localizedField": "USERDEFINEDCODE_3",
                "tableName": "IMITEM",
                "label": "CODE 3",
                "type": "lookup",
                "layout": WMCodesLookupLayout({codeType: '20' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_4",
                "localizedField": "USERDEFINEDCODE_4",
                "tableName": "IMITEM",
                "label": "CODE 4",
                "type": "lookup",
                "layout": WMCodesLookupLayout({codeType: '21' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_5",
                "localizedField": "USERDEFINEDCODE_5",
                "tableName": "IMITEM",
                "label": "CODE 5",
                "type": "lookup",
                "layout": WMCodesLookupLayout({codeType: '22' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_6",
                "localizedField": "USERDEFINEDCODE_6",
                "tableName": "IMITEM",
                "label": "CODE 6",
                "type": "lookup",
                "layout": WMCodesLookupLayout({codeType: '23' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_7",
                "localizedField": "USERDEFINEDCODE_7",
                "tableName": "IMITEM",
                "label": "CODE 7",
                "type": "lookup",
                "layout": WMCodesLookupLayout({codeType: '24' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_8",
                "localizedField": "USERDEFINEDCODE_8",
                "tableName": "IMITEM",
                "label": "CODE 8",
                "type": "lookup",
                "layout": WMCodesLookupLayout({codeType: '25' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_9",
                "localizedField": "USERDEFINEDCODE_9",
                "tableName": "IMITEM",
                "label": "CODE 9",
                "type": "lookup",
                "layout": WMCodesLookupLayout({codeType: '26' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_10",
                "localizedField": "USERDEFINEDCODE_10",
                "tableName": "IMITEM",
                "label": "CODE 10",
                "type": "lookup",
                "layout": WMCodesLookupLayout({codeType: '27' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDDATE_1",
                "localizedField": "USERDEFINEDDATE_1",
                "tableName": "IMITEM",
                "label": "Date 1",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_2",
                "localizedField": "USERDEFINEDDATE_2",
                "tableName": "IMITEM",
                "label": "Date 2",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_3",
                "localizedField": "USERDEFINEDDATE_3",
                "tableName": "IMITEM",
                "label": "Date 3",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_4",
                "localizedField": "USERDEFINEDDATE_4",
                "tableName": "IMITEM",
                "label": "Date 4",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_5",
                "localizedField": "USERDEFINEDDATE_5",
                "tableName": "IMITEM",
                "label": "Date 5",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_6",
                "localizedField": "USERDEFINEDDATE_6",
                "tableName": "IMITEM",
                "label": "Date 6",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_7",
                "localizedField": "USERDEFINEDDATE_7",
                "tableName": "IMITEM",
                "label": "Date 7",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_8",
                "localizedField": "USERDEFINEDDATE_8",
                "tableName": "IMITEM",
                "label": "Date 8",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_9",
                "localizedField": "USERDEFINEDDATE_9",
                "tableName": "IMITEM",
                "label": "Date 9",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_10",
                "localizedField": "USERDEFINEDDATE_10",
                "tableName": "IMITEM",
                "label": "Date 10",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDQUANTITY_1",
                "localizedField": "USERDEFINEDQUANTITY_1",
                "tableName": "IMITEM",
                "label": "Quantity 1",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_2",
                "localizedField": "USERDEFINEDQUANTITY_2",
                "tableName": "IMITEM",
                "label": "Quantity 2",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_3",
                "localizedField": "USERDEFINEDQUANTITY_3",
                "tableName": "IMITEM",
                "label": "Quantity 3",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_4",
                "localizedField": "USERDEFINEDQUANTITY_4",
                "tableName": "IMITEM",
                "label": "Quantity 4",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_5",
                "localizedField": "USERDEFINEDQUANTITY_5",
                "tableName": "IMITEM",
                "label": "Quantity 5",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_6",
                "localizedField": "USERDEFINEDQUANTITY_6",
                "tableName": "IMITEM",
                "label": "Quantity 6",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_7",
                "localizedField": "USERDEFINEDQUANTITY_7",
                "tableName": "IMITEM",
                "label": "Quantity 7",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_8",
                "localizedField": "USERDEFINEDQUANTITY_8",
                "tableName": "IMITEM",
                "label": "Quantity 8",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_9",
                "localizedField": "USERDEFINEDQUANTITY_9",
                "tableName": "IMITEM",
                "label": "Quantity 9",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_10",
                "localizedField": "USERDEFINEDQUANTITY_10",
                "tableName": "IMITEM",
                "label": "Quantity 10",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    }
]
const RefrencesLayout = [

    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDREFERENCE_1",
                "localizedField": "USERDEFINEDREFERENCE_1",
                "tableName": "IMITEM",
                "label": "Reference 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_2",
                "localizedField": "USERDEFINEDREFERENCE_2",
                "tableName": "IMITEM",
                "label": "Reference 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_3",
                "localizedField": "USERDEFINEDREFERENCE_3",
                "tableName": "IMITEM",
                "label": "Reference 3",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_4",
                "localizedField": "USERDEFINEDREFERENCE_4",
                "tableName": "IMITEM",
                "label": "Reference 4",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_5",
                "localizedField": "USERDEFINEDREFERENCE_5",
                "tableName": "IMITEM",
                "label": "Reference 5",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_6",
                "localizedField": "USERDEFINEDREFERENCE_6",
                "tableName": "IMITEM",
                "label": "Reference 6",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_7",
                "localizedField": "USERDEFINEDREFERENCE_7",
                "tableName": "IMITEM",
                "label": "Reference 7",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_8",
                "localizedField": "USERDEFINEDREFERENCE_8",
                "tableName": "IMITEM",
                "label": "Reference 8",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_9",
                "localizedField": "USERDEFINEDREFERENCE_9",
                "tableName": "IMITEM",
                "label": "Reference 9",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_10",
                "localizedField": "USERDEFINEDREFERENCE_10",
                "tableName": "IMITEM",
                "label": "Reference 10",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }



        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDCOMMENT",
                "tableName": "IMITEM",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    }
]
const HandlingLayout = (locationLayout) => [
    {
        "groupId": 1,
        "label": "Location Forward Pick",
        "fields": [
            {
                "name": "LOCATIONCLASSFORWARDPICK",
                "localizedField": "LOCATIONCLASSFORWARDPICK",
                "tableName": "IMITEM",
                "label": "Class",
                "type": "lookup",
                "layout": WMCodesLookupLayout({codeType: '72' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "LOCATIONSUBCLASSFORWARDPICK",
                "localizedField": "LOCATIONSUBCLASSFORWARDPICK",
                "tableName": "IMITEM",
                "label": "Subclass",
                "type": "lookup",
                "layout": WMCodesLookupLayout({codeType: '73' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            } ,
            {
                "name": "R_WAREHOUSE",
                "localizedField": "R_WAREHOUSE",
                "tableName": "IMITEM",
                "label": "Warehouse",
                "type": "lookup",
                "layout": IDWarehouseLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            } ,
            {
                "name": "R_LOCATION",
                "localizedField": "R_LOCATION",
                "tableName": "IMITEM",
                "label": "Loc - Primary",
                "type": "lookup",
                "layout": locationLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_LOCATIONBACKUPFORWARDPICK",
                "localizedField": "R_LOCATIONBACKUPFORWARDPICK",
                "tableName": "IMITEM",
                "label": "Loc - Backup",
                "type": "lookup",
                "layout": locationLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },{
                "name": "LOCATIONMINUNITSFORWARDPICK",
                "tableName": "IMITEM",
                "label": "Minimum Unit",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },{
                "name": "LOCATIONMAXUNITSFORWARDPICK",
                "tableName": "IMITEM",
                "label": "Maximum Unit",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            
        ]
    },{
        "groupId": 2,
        "label": "Location Replenishment",
        "fields": [
            {
                "name": "LOCATIONCLASSREPLENSHMENT",
                "localizedField": "LOCATIONCLASSREPLENSHMENT",
                "tableName": "IMITEM",
                "label": "Location Replenishment Class",
                "type": "lookup",
                "layout": WMCodesLookupLayout({codeType: '72' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "LOCATIONSUBCLASSREPLENSHMENT",
                "localizedField": "LOCATIONSUBCLASSREPLENSHMENT",
                "tableName": "IMITEM",
                "label": "Location Replenishment Subclass",
                "type": "lookup",
                "layout": WMCodesLookupLayout({codeType: '73' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            } ,{
                "name": "",
                "tableName": "IMITEM",
                "label": "",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },
            {
                "name": "R_LOCATIONPRIMARYREPLENSMENT",
                "localizedField": "R_LOCATIONPRIMARYREPLENSMENT",
                "tableName": "IMITEM",
                "label": "Loc - Primary Replenishment",
                "type": "lookup",
                "layout": locationLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_LOCATIONBACKUPREPLENSMENT",
                "localizedField": "R_LOCATIONBACKUPREPLENSMENT",
                "tableName": "IMITEM",
                "label": "Loc - Backup Replenishment",
                "type": "lookup",
                "layout": locationLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },{
                "name": "LOCATIONMINUNITSREPLENISHMENT",
                "tableName": "IMITEM",
                "label": "Location Minimum Unit Replenishment",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },{
                "name": "LOCATIONMAXUNITSREPLENISHMENT",
                "tableName": "IMITEM",
                "label": "Location Maxmimum Unit Replenishment",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            
        ]
    },{
        "groupId": 3,
        "label": "Location Reserve",
        "fields": [
            {
                "name": "LOCATIONCLASSRESERVE",
                "localizedField": "LOCATIONCLASSRESERVE",
                "tableName": "IMITEM",
                "label": "Location Reserve Class",
                "type": "lookup",
                "layout": WMCodesLookupLayout({codeType: '72' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            } ,{
                "name": "LOCATIONSUBCLASSRESERVE",
                "localizedField": "LOCATIONSUBCLASSRESERVE",
                "tableName": "IMITEM",
                "label": "Location Reserve Subclass",
                "type": "lookup",
                "layout": WMCodesLookupLayout({codeType: '73' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            } ,{
                "name": "",
                "tableName": "IMITEM",
                "label": "",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },
            {
                "name": "R_LOCATIONPRIMARYRESERVE",
                "localizedField": "R_LOCATIONPRIMARYRESERVE",
                "tableName": "IMITEM",
                "label": "Loc - Primary Reserve",
                "type": "lookup",
                "layout": locationLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_LOCATIONBACKUPRESERVE",
                "localizedField": "R_LOCATIONBACKUPRESERVE",
                "tableName": "IMITEM",
                "label": "Loc - Backup Reserve",
                "type": "lookup",
                "layout": locationLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },{
                "name": "",
                "tableName": "IMITEM",
                "label": "",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },{
                "name": "",
                "tableName": "IMITEM",
                "label": "",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }
            
        ]
    } ,
    {
        "groupId": 4,
        "label": "Handling",
        "fields": [
            {
                "name": "CAREINSTRUCTIONS",
                "localizedField": "CAREINSTRUCTIONS",
                "tableName": "IMITEM",
                "label": "Instruction",
                "type": "lookup",
                "layout": WMCodesLookupLayout({codeType: '85' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },{
                "name": "STACKHEIGHT",
                "tableName": "IMITEM",
                "label": "Stack Height",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "HAZARDOUSFLAG",
                "tableName": "IMITEM",
                "label": "Hazarodus",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },{
                "name": "R_HAZARDOUS",
                "tableName": "IMITEM",
                "label": "Inventory Unit",
                "type": "lookup",
                "layout": edHazardousLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "SHIPSELECTION",
                "tableName": "IMITEM",
                "label": "Use Serial #",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 5,
        "label": "Pallet Building",
        "fields": [
            {
                "name": "PALLETREFERENCE",
                "localizedField": "PALLETREFERENCE",
                "tableName": "IMITEM",
                "label": "Description",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            } ,{
                "name": "PALLETSIZECODE",
                "tableName": "IMITEM",
                "label": "Size",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,{
                "name": "PALLETPATTERNROW",
                "tableName": "IMITEM",
                "label": "Row",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,{
                "name": "PALLETPATTERNCOLUMN",
                "tableName": "IMITEM",
                "label": "Column",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,{
                "name": "PALLETPATTERNHEIGHT",
                "tableName": "IMITEM",
                "label": "Height",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    },
    {
        "groupId": 6,
        "label": "Sublot Handling",
        "fields": [
            {
                "name": "SUBLOTUNIQUEFLAG",
                "localizedField": "SUBLOTUNIQUEFLAG",
                "tableName": "IMITEM",
                "label": "Sublot Unique",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }  
        ]
    }
]
const KitLayout = (kitLayout) => [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "R_ITEMKITTCODE",
                "localizedField": "R_ITEMKITTCODE",
                "tableName": "IMITEM",
                "label": "Kit Code",
                "type": "lookup",
                "layout": kitLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,


            }  
        ]
    },
     
]
export {
    SearchLayout,
    PrimaryLayout,
    AdditionalLayout,
    UOMLayout,
    HandlingLayout,
    StatusLayout,
    CodesLayout,
    RefrencesLayout,
    KitLayout
}